import { FileData } from "@/utils/types";

export const getFilesFromTree = (
  fileTree: FileData[],
  canvasId: string,
): string[] => {
  const traverse = (fileNodes: FileData[]): string[] => {
    const files: string[] = [];

    for (const node of fileNodes) {
      if (node.type === "file") {
        files.push(node.fullPath);
      } else if (node.items) {
        files.push(...traverse(node.items));
      }
    }

    return files;
  };

  const fullFilePaths = traverse(fileTree);
  return fullFilePaths.map((path) => path.split(`${canvasId}/`)[1]);
};
